import defaultStringCTOR from "./src/CTORCreator.js";
export default defaultStringCTOR;
